<div
  class="fixed-bottom p-1 bg-gradient bg-secondary-subtle d-flex flex-column flex-lg-row"
>
  <div class="text-center">
    تمامی حقوق مالکیت معنوی این ‌سایت برای موسسه مدیریت حامیان نواندیش افرا
    محفوظ است.
  </div>
  <div
    class="ms-lg-auto text-center"
    style="direction: ltr; font-family: Verdana"
  >
    © Copyright 2025 Afra. All rights reserved.
  </div>
</div>
